import type * as Types from 'app/types/graphql';

export type PlatformProductSelectFragment = Pick<
  Types.PlatformProduct,
  | 'id'
  | 'baseID'
  | 'handle'
  | 'title'
  | 'image'
  | 'status'
  | 'onlineStoreURL'
  | 'publishedAt'
  | 'templateSuffix'
>;

export type PlatformProductVariantSelectFragment = Pick<
  Types.PlatformProductVariant,
  'baseID' | 'title' | 'price' | 'compareAtPrice'
>;

export const PlatformProductSelectFragmentDoc = `
    fragment PlatformProductSelect on PlatformProduct {
  id
  baseID
  handle
  title
  image
  status
  onlineStoreURL
  publishedAt
  templateSuffix
}
    `;
export const PlatformProductVariantSelectFragmentDoc = `
    fragment PlatformProductVariantSelect on PlatformProductVariant {
  baseID
  title
  price
  compareAtPrice
}
    `;
